"use strict";

var _taggedTemplateLiteral = require("/Users/satoshi/Documents/botlogy/projects/Ikitsuke-clinic/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  padding: 5rem;\n  overflow: scroll;\n  max-width: 100%;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  font-size: var(--font-size-default);\n  font-weight: bold;\n  color: var(--color-grey-dark-2);\n  margin: 0 0.5rem;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  font-size: var(--font-size-default);\n  font-weight: bold;\n  color: var(--color-primary-light-3);\n  margin: 0 0.5rem;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  padding: 0.75rem;\n  display: flex;\n  justify-content: flex-end;\n\n  & svg[class] {\n    color: var(--color-primary-dark-1);\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  padding: 1.5rem;\n  overflow: scroll;\n  max-width: 100%;\n  max-height: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  padding: 0.5rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  overflow: unset;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  max-width: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importDefault(require("styled-components"));

var gallery_card_component_1 = __importDefault(require("../../common-components/gallery-card/gallery-card.component"));

exports.NODE_GALLERY_CARD_MAX_WIDTH = '30rem';
exports.NODE_MAX_HEIGHT = '40rem';
exports.StyledScenarioGalleryCardWrapperDiv = styled_components_1.default.div(_templateObject(), exports.NODE_GALLERY_CARD_MAX_WIDTH);
exports.StyledGalleryCard = styled_components_1.default(gallery_card_component_1.default)(_templateObject2());
exports.StyledScenarioNodeGalleryContentDiv = styled_components_1.default.div(_templateObject3());
exports.StyledScenarioNodeWrapperDiv = styled_components_1.default.div(_templateObject4(), exports.NODE_MAX_HEIGHT);
exports.StyledEditButtonBoxDiv = styled_components_1.default.div(_templateObject5());
exports.StyledEditButtonTextSpan = styled_components_1.default.span(_templateObject6());
exports.StyledDetailButtonTextSpan = styled_components_1.default.span(_templateObject7());
exports.StyledModalScenarioNodeWrapperDiv = styled_components_1.default.div(_templateObject8());